import React from 'react'
import type { Element } from 'react'
import { CardContainer } from './styles'

type CardProps = {
    flexDirectionRow?: boolean,
    center?: boolean,
    children: Element<any>,
    className?: string
}

export const Card = ({
    flexDirectionRow = false,
    center = false,
    className,
    children
}: CardProps) => {
    return (
        <CardContainer
            className={className}
            flexDirectionRow={flexDirectionRow}
            center={center}>
            {children}
        </CardContainer>
    )
}
